import { css } from 'styled-components';

export const addMenuHeightMixin = css<{ $addMainMenuHeaderHeight: boolean }>`
  ${Styles.desktop} {
    ${p =>
      p.$addMainMenuHeaderHeight &&
      css`
        margin-block-start: 14rem;
      `}
  }
`;
